import { Instagram } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Motion";
import PageHeader from "../components/layout/PageHeader";
import { business } from "../data/site";
import SEO from "../components/SEO";

// Instagram post shortcodes from influencers who featured Shaan Curry House.
const posts = [
  "Ctzv47igEqX",
  "DMDad6nxCKd",
  "DGyZa9KO_Xq",
  "CxY0ATAgbML",
  "C3fc0-fgrGq",
  "Cy99MfKgsNd",
  "C2xNSYCAEde",
  "CyPOztyRUqq",
  "CyTirBWrXMF",
  "Cxa4I_VA6A6",
  "C119RcUs4qE",
  "C1HsUxDg_xF",
];

export default function Featured() {
  return (
    <div data-testid="featured-page">
      <SEO
        route="featured"
        fallbackTitle="Food Bloggers Love Shaan Curry House"
        fallbackDescription="See what Ottawa food bloggers and press say about Shaan Curry House."
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Food Bloggers", url: "/featured" },
        ]}
      />
      <PageHeader
        eyebrow="Straight From The 'Gram"
        title="Loved by Food Bloggers"
        subtitle="From viral reels to five-star raves, Ottawa's favourite food bloggers keep pulling up for our curries. Grab a seat and see what all the fuss is about."
      />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20">
        <StaggerGroup className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {posts.map((code) => (
            <StaggerItem key={code}>
              <div className="rounded-2xl overflow-hidden bg-white shadow-xl border border-white/10"
                data-testid={`ig-embed-${code}`}>
                <iframe
                  title={`Instagram post ${code}`}
                  src={`https://www.instagram.com/p/${code}/embed/`}
                  className="w-full"
                  height="640"
                  loading="lazy"
                  scrolling="no"
                  frameBorder="0"
                />
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <Reveal className="text-center mt-14">
          <a href={business.instagram} target="_blank" rel="noreferrer" data-testid="featured-ig-btn"
            className="inline-flex items-center gap-3 bg-[#ffd100] text-[#0a0a0a] font-bold text-lg px-8 py-4 rounded-full hover:bg-[#e5bc00] transition-colors">
            <Instagram size={22} /> Follow us @shaancurryhouseottawa
          </a>
        </Reveal>
      </section>
    </div>
  );
}
